import { render, staticRenderFns } from "./OrticInputPercentageControl.vue?vue&type=template&id=3b540e02&"
import script from "./OrticInputPercentageControl.vue?vue&type=script&lang=js&"
export * from "./OrticInputPercentageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports